











































































































































import Vue from "vue";
import axios from "axios";
import store from "@/store";
import router from "@/router";
import InfoCard from "@/components/InfoCard.vue";
import profile from "@/interfaces/profile";
import { format, parseISO } from "date-fns";

export default Vue.extend({
	components: {
		InfoCard,
	},
	data() {
		return {
			skillwords: [{ id: 1, name: "Järjestely" }],
			worker: {} as any,
			aml: [] as any,
			mainProfile: {} as any,
			languageSkills: [] as any,
			profiles: [] as any[],
		};
	},
	computed: {
		storeAuthObject() {
			return this.$store.state.strongAuth;
		},
		storeJwt() {
			return this.$store.state.jwt;
		},
	},
	methods: {
		// getWorkerData() {
		//     axios.get("Itsepalvelu/user").then(resp => {
		//         this.worker = resp.data;
		//         axios.get(`Itsepalvelu/user/aml/${resp.data.uid}`).then(r => {
		//             this.worker.ammattiluokitukset = r.data;
		//     })
		//     })
		// },
		// get all organization ammattiluokitukset
		// getAml() {
		//     axios.get(`Itsepalvelu/aml`).then(resp => {
		//         resp.data.forEach((a : any) => {
		//             this.aml.push(a);
		//         })
		//     });
		// },
		goToSkillBoard() {
			router.push({
				name: "Skillboard",
				params: {
					org: store.state.org as string,
				},
			});
		},
		getWorkerData() {
			axios.get("Itsepalvelu/user").then((resp) => {
				this.worker = resp.data;
				axios.get(`Itsepalvelu/user/aml/${resp.data.uid}`).then((r) => {
					this.worker.ammattiluokitukset = r.data;
					axios.get("Profile/profiles").then((response) => {
						response.data.forEach((pr: any) => {
							if (pr.perusprofiili) {
								this.mainProfile = pr;
								this.languageSkills = pr.kielitaidot;
							}
						});
						if (response.data.length < 1) {
							axios
								.post(`Profile/profile`, {
									tyonhakijaId: this.worker.uid,
									perusprofiili: true,
									profiilinimi: "Perusprofiili",
								} as profile)
								.then(() => {
									axios.get("Profile/profiles").then((response) => {
										response.data.forEach((pr: any) => {
											if (pr.perusprofiili) this.mainProfile = pr;
											this.profiles.push(pr);
										});
									});
								});
						} else this.profiles = response.data;
					});
				});
			});
		},
		displayLangSkill(skillLvl: number) {
			switch (skillLvl) {
				case 1:
					return "A1";
				case 2:
					return "A2";
				case 3:
					return "B1";
				case 4:
					return "B2";
				case 5:
					return "C1";
				case 6:
					return "C2";
				case 7:
					return this.$t("native-language");
				default:
					return "-";
			}
		},
		displayWorkExpYears() {},
		dateDisplay(d: string|null): string {
			return d ? format(parseISO(d), "d.M.Y") : ''
		},
	},
	mounted() {
		this.getWorkerData();
		//this.getAml();
	},

	watch: {
		storeJwt: {
			handler: async function handle(newVal) {
				if (newVal) {
					try {
						const resp = await axios.get("auth/TestAuth");
						console.log(resp);
					} catch (error) {
						router.push({
							name: "Home",
							params: {
								org: store.state.org as string,
							},
						});
					}
				} else {
					router.push({
						name: "Home",
						params: {
							org: store.state.org as string,
						},
					});
				}
			},
			immediate: true,
		},
	},
});
